var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RibbonGroupBase } from '../ribbon-interfaces';
export var TABLE_ID = '_table';
/**
 * Tables group implementation for Insert tab
 * @private
 */
var TablesGroup = /** @class */ (function (_super) {
    __extends(TablesGroup, _super);
    function TablesGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get the Ribbon items for Tables group
     * @returns {RibbonGroupModel} - The ribbon items for Tables group
     * @private
     */
    TablesGroup.prototype.getGroupModel = function () {
        return {
            header: this.localObj.getConstant('Table'),
            groupIconCss: 'e-icons e-de-ctnr-table',
            enableGroupOverflow: true,
            overflowHeader: this.localObj.getConstant('Table'),
            collections: [{
                    items: [{
                            type: 'Button',
                            keyTip: 'T',
                            buttonSettings: {
                                content: this.localObj.getConstant('Table'),
                                iconCss: 'e-icons e-de-ctnr-table',
                                isToggle: false,
                                clicked: this.insertTableHandler.bind(this)
                            },
                            id: this.ribbonId + TABLE_ID,
                            ribbonTooltipSettings: {
                                content: this.localObj.getConstant('Insert a table into the document')
                            }
                        }]
                }]
        };
    };
    TablesGroup.prototype.insertTableHandler = function () {
        this.container.documentEditor.showDialog('Table');
    };
    /**
     * Update selection to reflect current state
     * @returns {void}
     * @private
     */
    TablesGroup.prototype.updateSelection = function () {
        var isPlainContentControl = this.documentEditor.selectionModule.isPlainContentControl();
        if (isPlainContentControl) {
            this.container.ribbon.ribbon.disableItem(this.ribbonId + TABLE_ID);
        }
        else {
            this.container.ribbon.ribbon.enableItem(this.ribbonId + TABLE_ID);
        }
    };
    return TablesGroup;
}(RibbonGroupBase));
export { TablesGroup };
